<template>
  <b-container fluid class="home p-0 m-0">
    <vue-loading
      :active="isLoading"
      :is-full-page="true"
      :height="100"
      :width="100"
      :color="'#2067a4'"
      :can-cancel="false"
      loader="spinner"
    />

    <b-row class="p-0 m-0">
      <b-col class="m-0 p-0 position-relative text-center ml-auto mr-auto">
        <div class="video-container">
          <button id="snapButton" class="" @click="snap" v-if="!isLoading">
            <i class="fa fa-camera fa-2x"></i>
          </button>

          <div
            v-if="isLoading"
            class="position-absolute px-4"
            style="top: 50px; width: 100vw; text-align: center; z-index: 100000"
          >
            <b-row>
              <b-col>
                <b-alert :show="isLoading" variant="info" class="text-center">
                  Ustvarjanje portreta traja približno 1 minuto. Medtem, ko
                  čakate, spoznajte nekaj informacij o starosti in o starejših.
                </b-alert>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-center mt-0 mb-5">
                <swiper
                  :slides-per-view="1"
                  :space-between="1"
                  :modules="modules"
                  :autoplay="{
                    delay: 5000,
                  }"
                  pagination
                  @swiper="onSwiper"
                  @slideChange="onSlideChange"
                >
                  <swiper-slide
                    v-for="(slide, idx) in slides"
                    :key="'slide_' + idx"
                  >
                    <b-card
                      :body-class="'px-2 py-1 d-flex flex-column text-center justify-content-center align-content-center align-items-center overflow-hidden'"
                      style="text-overflow: ellipsis; min-height: 170px"
                    >
                      <div
                        class="mb-0"
                        style="
                          overflow: hidden;
                          text-overflow: ellipsis;
                          font-size: 16px;
                          max-lines: 4;
                          overflow-elippsis: ellipsis;
                        "
                      >
                        <h5>{{ slide.title }}</h5>
                        <p class="pb-0">
                          {{ slide.body }}
                        </p>
                      </div>
                    </b-card>
                  </swiper-slide>
                </swiper>
              </b-col>
            </b-row>
          </div>

          <video id="webcam" autoplay playsinline></video>

          <div
            v-if="isLoading"
            class="position-absolute px-4"
            style="
              z-index: 100000;
              bottom: 30px;
              width: 100svw;
              text-align: center;
            "
          >
            <b-row>
              <b-col class="text-center mt-0 mb-5">
                <b-button
                  variant="primary"
                  block
                  class="text-white m-auto"
                  style="max-width: 300px"
                  @click="$router.go()"
                >
                  <i class="fa fa-refresh"></i> Ponovni zajem slike</b-button
                >
              </b-col>
            </b-row>
          </div>

          <div
            v-if="!isLoading"
            class="faceTraceOverlay px-4"
            style="
              position: absolute;
              z-index: 10;
              left: 0;
              right: 0;
              bottom: 0;
              top: 0;
              display: flex;
              align-self: center;
              justify-content: center;
              align-items: center;
              margin: auto;
            "
          >
            <img
              :src="require('../assets/face_overlay.png')"
              style="
                max-width: 600px;
                max-height: 630px;
                width: 100%;
                height: auto;
              "
            />
          </div>
        </div>
      </b-col>
    </b-row>

    <div class="d-none" style="width: 600px; height: 635px">
      <canvas
        id="canvas"
        class=""
        style="width: 600px; height: 635px"
        width="600"
        height="635"
      ></canvas>
    </div>
  </b-container>
</template>

<script>
import VueLoading from "vue-loading-overlay";
import Webcam from "webcam-easy";
import { Navigation, Pagination } from "swiper";
import { SwiperCore, Swiper, SwiperSlide } from "swiper-vue2";

SwiperCore.use([Navigation, Pagination]);

export default {
  name: "HomeView",
  components: {
    VueLoading,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
  data() {
    return {
      isLoading: false,
      webcamElement: null,
      canvasElement: null,
      snapSoundElement: null,
      webcam: null,
      image: null,
      old: null,
      finalImageDataUrl: null,
      slides: [
        {
          title: "Modrost in odločanje",
          body: "Starejši ljudje sprejemajo premišljene odločitve zaradi bogatih izkušenj, zato so odlični svetovalci.",
        },
        {
          title: "Prispevek k družbi",
          body: "Starejši so ključni za prenos znanja, tradicij in kulture, oblikujejo identiteto skupnosti.",
        },
        {
          title: "Učenje in kreativnost",
          body: "Starost ni ovira za učenje ali ustvarjalnost. Mnogi v poznih letih začnejo nove hobije ali kariero.",
        },
        {
          title: "Družbena povezanost",
          body: "Starejši imajo pomembno vlogo kot skrbniki in družabniki, krepijo družinske vezi in prenašajo vrednote.",
        },
        {
          title: "Gospodarski vpliv",
          body: "Starejši prispevajo k gospodarstvu kot potrošniki in delovna sila, njihova modrost pa spodbuja inovacije.",
        },
      ],
    };
  },
  mounted() {
    this.webcamElement = document.getElementById("webcam");
    this.canvasElement = document.getElementById("canvas");
    this.webcam = new Webcam(
      this.webcamElement,
      "user",
      this.canvasElement,
      null
    );

    this.webcam
      .start({
        width: 600,
        height: 635,
        image_format: "jpeg",
        jpeg_quality: 100,
      })
      .then((result) => {
        console.log("webcam started", result);

        //this.isLoading = true;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    snap() {
      // Capture the image to the original canvas
      this.webcam.snap();
      this.isLoading = true;

      // Target dimensions
      const targetWidth = 600;
      const targetHeight = 635;

      // Original video dimensions
      const videoWidth = this.webcamElement.videoWidth;
      const videoHeight = this.webcamElement.videoHeight;

      // Determine the "safe size" by scaling the video feed to match the target aspect ratio
      let safeWidth, safeHeight;
      const videoAspectRatio = videoWidth / videoHeight;
      const targetAspectRatio = targetWidth / targetHeight;

      // Check if video needs to be scaled based on width or height
      if (videoAspectRatio > targetAspectRatio) {
        // Scale based on height
        safeHeight = targetHeight;
        safeWidth = safeHeight * videoAspectRatio;
      } else {
        // Scale based on width
        safeWidth = targetWidth;
        safeHeight = safeWidth / videoAspectRatio;
      }

      // Calculate the crop position for center top cropping
      let sourceX = (safeWidth - targetWidth) / 2;
      let sourceY = (safeHeight - targetHeight) / 2; // Center-center cropping

      // Create a new canvas element for resizing and cropping
      let intermediateCanvas = document.createElement("canvas");
      let intermediateContext = intermediateCanvas.getContext("2d");
      intermediateCanvas.width = safeWidth;
      intermediateCanvas.height = safeHeight;

      // Draw the video feed onto the intermediate canvas, scaled to safe size
      intermediateContext.drawImage(
        this.webcamElement,
        0,
        0,
        videoWidth,
        videoHeight,
        0,
        0,
        safeWidth,
        safeHeight
      );

      // Create final canvas for the cropped image
      let finalCanvas = document.createElement("canvas");
      let finalContext = finalCanvas.getContext("2d");
      finalCanvas.width = targetWidth;
      finalCanvas.height = targetHeight;

      // Draw the cropped area onto the final canvas
      finalContext.drawImage(
        intermediateCanvas,
        sourceX,
        sourceY,
        targetWidth,
        targetHeight,
        0,
        0,
        targetWidth,
        targetHeight
      );

      // Export the image from the final canvas
      this.finalImageDataUrl = finalCanvas.toDataURL("image/jpeg", 0.9);
      console.log("finalImageDataUrl", this.finalImageDataUrl);

      // let a = document.createElement("a"); // Create <a>
      // a.href = this.finalImageDataUrl; // Image Base64 goes here
      // a.download = "snap.png"; // File name here
      // a.click(); // Trigger download

      this.postData();
    },

    async postData() {
      let formData = new FormData();
      //formData.append("file", this.dataURLtoFile(this.image, "snap.png"));
      formData.append(
        "file",
        this.dataURLtoFile(this.finalImageDataUrl, "snap.png")
      );
      formData.append(
        "prompt",
        "Make the person on photo look about 70 years old."
      );
      // formData.append("negativePrompt", "Do not duplicate face.");

      let url = `https://portreti-spostovanja.sopotniki.org/postaraj`;
      try {
        let reponse = await this.$axios.post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("reponse", reponse);
        this.old = reponse.data.fileId;
        this.$router.push({
          name: "result",
          params: { fileId: reponse.data.fileId },
        });
      } catch (e) {
        console.error(e, "Poskušam ponovno ...");
        this.postData();
      }
    },

    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[arr.length - 1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    onSwiper(swiper) {
      console.log("swiper", swiper);
    },
    onSlideChange() {
      console.log("slide change");
    },
  },
};
</script>
